import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "store";
import { Col, Row } from "antd";
import AuthLeftSideBar from "./AuthLeftSideBar";
import LoginRightSideBar from "./LoginRightSideBar";
import { authLeftColSpan, authRightColSpan } from "data/authConstants";

export default function Login() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const [isBtnDisabled, setBtnDisabled] = useState(false);
  const onSubmit = async (values) => {
    const { email, password } = values;
    setBtnDisabled(true);
    await dispatch(login(email, password));
    setBtnDisabled(false);
  };

  const userAgent = window.navigator.userAgent;
  const isOldBrowser =
    userAgent.includes("MSIE") || userAgent.includes("Trident/");

  return (
    <div className="form-login-page">
      <Row>
        <Col className="form-login-left" span={authLeftColSpan}>
          <AuthLeftSideBar />
        </Col>
        <Col className="form-login-right" span={authRightColSpan}>
          <LoginRightSideBar
            isOldBrowser={isOldBrowser}
            isAuthenticated={isAuthenticated}
            onSubmit={onSubmit}
            isBtnDisabled={isBtnDisabled}
          />
        </Col>
      </Row>
    </div>
  );
}
